import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MembershipSection from './components/MembershipSection';
import ServiceFaq from './components/ServiceFaq';

const ServicesPage = () => (
  <div className="min-h-screen bg-white font-sans">
    <Navbar />
    <div style={{ paddingTop: '64px' }}>
      <MembershipSection />
      <ServiceFaq />
    </div>
    <Footer />
  </div>
);

export default ServicesPage;
